<template>
  <v-container fluid grid-list-xl>
    <v-layout row wrap>
      <v-flex xs12 md8 offset-md1>
        <v-card>
          <v-card-title>
            <h4>Sent to TWC</h4>
            <v-spacer></v-spacer>
            <v-btn small @click="searchOrders()" color="primary" :loading="ordersLoading" :disabled="ordersLoading" fab flat>
              <v-icon>refresh</v-icon>
            </v-btn>
          </v-card-title>
          <v-divider></v-divider>
          <!-- <pre>{{orders}}</pre> -->
          <v-card-text>
            <v-data-table id="orderTable" :headers="headers" item-key="id" :items="orders" :loading="ordersLoading" :pagination.sync="pagination" :total-items="totalOrders" :rows-per-page-items="rowsPerPageItems" :expand="true">
              <v-progress-linear slot="progress" color="primary" indeterminate></v-progress-linear>
              <template slot="items" slot-scope="props">
                <td @click="props.expanded = !props.expanded" v-html="deliveryOrInstall(props.item.orderID)"></td>
                <td @click="props.expanded = !props.expanded" width="20%"><v-btn small flat color="primary" target="_blank" :to="`/order/${props.item.orderID._id}`">{{ props.item.orderID.orderCode }}</v-btn></td>
                <td @click="props.expanded = !props.expanded"><v-btn small flat color="primary" @click="selectOrder(props.item.orderID._id)">{{props.item.orderID.customerID.firstName}} {{props.item.orderID.customerID.lastName}}</v-btn></td>
                <td @click="props.expanded = !props.expanded" width="25%" v-html="getProducts(props.item.orderID.orderCode)"></td>
                <td @click="props.expanded = !props.expanded" width="15%" v-html="getStatusHtml(props.item.twcStatus)"></td>
                <td @click="props.expanded = !props.expanded">{{ new Date(props.item.twcOrderDate).getDate() + "/" + (new Date(props.item.twcOrderDate).getMonth() + 1) + "/" + new Date(props.item.twcOrderDate).getFullYear() }}</td>
                <td @click="props.expanded = !props.expanded">{{ new Date(props.item.twcEstDueDate).getDate() + "/" + (new Date(props.item.twcEstDueDate).getMonth() + 1) + "/" + new Date(props.item.twcEstDueDate).getFullYear() }}</td>
              </template>
              <template slot="expand" slot-scope="props">
                <div style="width:60%; margin:0 auto; text-align: center; background:#eee;">
                  <h2>Individual TWC Orders - {{ props.item.orderID.orderCode }}</h2>
                  <table width="100%" >
                    <template>
                      <thead>
                        <tr>
                          <th class="text-left"></th>
                          <th class="text-left">Order Number</th>
                          <th class="text-left">Status</th>
                          <th class="text-left">Date</th>
                        </tr>
                      </thead>
                      <tbody>
                        <tr v-for="(item, index) in getOrdersByOrderCode(props.item.orderID.orderCode)" :key="index">
                          <td v-html="productAssets[item.type]" width="10%"></td>
                          <td width="30%">{{item.twcOrderNumber}}</td>
                          <td width="30%" v-html="getStatusHtml(item.twcStatus)"></td>
                          <td width="30%">{{ new Date(item.twcEstDueDate).getDate() + "/" + (new Date(item.twcEstDueDate).getMonth() + 1) + "/" + new Date(item.twcEstDueDate).getFullYear() }}</td>
                        </tr>
                      </tbody>
                    </template>
                  </table>
                  <!-- <v-data-table
                    :headers="headersDrop"
                    :items="getOrdersByOrderCode(props.item.orderID.orderCode)"
                    hide-default-footer: true
                    class="elevation-1"
                    :pagination.sync="pagination"
                  >
                    <template slot="items" slot-scope="props">
                      <td v-html="productAssets[props.item.type]" width="30%"></td>
                      <td>{{props.item.twcOrderNumber}}</td>
                      <td>{{props.item.twcStatus}}</td>
                      <td>{{ new Date(props.item.twcEstDueDate).getDate() + "/" + (new Date(props.item.twcEstDueDate).getMonth() + 1) + "/" + new Date(props.item.twcEstDueDate).getFullYear() }}</td>
                    </template>
                  </v-data-table> -->
                </div>
              </template>
              <!-- <template slot="expand" slot-scope="props">
                <v-card flat>
                  <div v-html="getSubProductsHtml()">{{props.item.twcOrderDate}}</div>
                </v-card>
              </template> -->
              <template slot="no-data">
                {{ loadingText }}
              </template>
            </v-data-table>
          </v-card-text>
        </v-card>
      </v-flex>

      <v-flex xs12 md2>
        <v-card>
          <v-card-title>
            <h4>Search and Filter</h4>
          </v-card-title>
          <v-divider></v-divider>
          <v-card-text>
            <!-- <v-select v-model="enabledStatuses" :items="availableStatuses" chips clearable label="Filter Status" multiple @input="searchOrders()"></v-select> -->
            <v-spacer></v-spacer>
            <!-- <v-select
              v-model="enabledUsers"
              :items="availableUsers"
              label="Filter Users"
              item-value="id"
              item-text="firstName"
              multiple
              chips clearable
              menu-props="bottom"
              @input="searchOrders()"
            ></v-select> -->
            <v-spacer></v-spacer>
            <v-text-field v-model="search" append-icon="search" label="Search" single-line hide-details @change="searchOrders()"></v-text-field>
            <v-spacer class="v-text-field"></v-spacer>
            <v-select v-model="enabledInstallorDelivery" :items="availableInstallorDelivery" chips clearable label="Filter Order Type" multiple @input="searchOrders()"></v-select>
          </v-card-text>
        </v-card>
      </v-flex>
    </v-layout>

    <!-- Customer Popup -->
    <v-dialog v-model="customerDialog" max-width="600px">
      <v-card v-if="selectedOrder">
        <v-card-title>{{ selectedOrder.orderID.orderCode }} - Customer Details</v-card-title>
        <v-divider></v-divider>
        <v-card-text>
          <p>Name: {{ selectedOrder.orderID.customerID.firstName }} {{ selectedOrder.orderID.customerID.lastName }}</p>
          <p>Phone: {{ selectedOrder.orderID.customerID.phone }}</p>
          <p>Email: {{ selectedOrder.orderID.customerID.email }}</p>
          <p>Address: {{ selectedCustomerAddress }}</p>
        </v-card-text>
        <v-divider></v-divider>
        <v-card-actions>
          <v-btn color="primary" flat @click="customerDialog = false">Close</v-btn>
          <v-spacer></v-spacer>
          <v-btn color="primary" flat target="_self" :to="`/customers/${selectedOrder.orderID.customerID._id}`">Go to Customer</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>

  </v-container>
</template>

<script>
import OrderService from '@/services/OrderService'

export default {
  name: 'orders',
  data () {
    return {
      showDetails: {
        0: false,
        1: false,
        2: false,
        3: false,
        4: false,
        5: false,
        6: false,
        7: false,
        8: false,
        9: false,
        10: false
      },
      CMs: [],
      selectedCustomerAddress: '',
      dialog: false,
      headers: [
        { text: '', value: '' },
        { text: 'Order Code', value: 'orderCode' },
        { text: 'Customer Name', value: 'customerName' },
        { text: 'Products', value: 'products' },
        { text: 'Status', value: 'twcOrderID' },
        { text: 'Order Date', value: 'twcOrderDate' },
        { text: 'Estimated Completion', value: 'twcEstDueDate' }
      ],
      headersDrop: [
        { text: '', value: '' },
        { text: 'TWC Order Number', value: 'twcOrderNumber' },
        { text: 'TWC Status', value: 'twcStatus' },
        { text: 'Estimated Completion', value: 'twcEstDueDate' }
      ],
      orders: [],
      orders2: [],
      isModalVisible: false,
      currentOrder: null,
      modal: null,
      users: null,
      task: {
        orderID: null,
        type: null,
        remarks: null,
        dueDate: null,
        assigned: null,
        done: null
      },
      snackbar: false,
      popupText: null,
      ordersLoading: false,
      customerDialog: false,
      confirmDialog: false,
      selectedOrder: null,
      search: null,
      enabledUsers: [],
      availableUsers: [],
      pagination: {
        sortBy: 'twcOrderDate',
        descending: true,
        rowsPerPage: 30
      },
      totalOrders: 0,
      loadingText: 'Loading...',
      rowsPerPageItems: [10, 20, 30],
      enabledStatuses: ['Processing'],
      availableStatuses: ['Pending',
        'Processing',
        'Awaiting Check Measure',
        'Sent to Factory',
        'Completed by Factory',
        'Sent to Customer',
        'Need to Book Check Measure'],
      productAssets: {
        'Roller Blind': '<img class="productImage" src="/static/productAssets/roller-blinds.png">',
        'Shutter': '<img class="productImage" src="/static/productAssets/shutters.png">',
        'Roman Blind': '<img class="productImage" src="/static/productAssets/roman-blinds.png">',
        'Panel Glides': '<img class="productImage" src="/static/productAssets/panel-glide-blinds.png">',
        '25mm Aluminium': '<img class="productImage" src="/static/productAssets/venetian-blinds.png">',
        'Curtain Tracks - Residential': '<img class="productImage" src="/static/productAssets/curtains.png">',
        'Curtain Tracks - Designer': '<img class="productImage" src="/static/productAssets/curtains.png">',
        'Verticals': '<img class="productImage" src="/static/productAssets/vertical-blinds.png">',
        'Curtain': '<img class="productImage" src="/static/productAssets/curtains.png">',
        'Honeycomb Blind': '<img class="productImage" src="/static/productAssets/honeycomb-blinds.png">',
        'Venetian Blind': '<img class="productImage" src="/static/productAssets/venetian-blinds.png">',
        'Double Roller Blind': '<img class="productImage" src="/static/productAssets/double-roller-blinds.png">',
        'Linked Roller Blind': '<img class="productImage" src="/static/productAssets/linked-roller-blinds.png">'
      },
      enabledInstallorDelivery: ['Install', 'Delivery'],
      availableInstallorDelivery: ['Install', 'Delivery']
    }
  },
  mounted () {
    this.getOrders()
    // if production sent to dashboard
    // if (window.location.href.indexOf('localhost') > 0 || window.location.href.indexOf('stagingadmin') > 0) {
    // } else {
    //   this.$router.push('/dashboard')
    // }
  },
  watch: {
    pagination: {
      handler () {
        this.getOrders().then(data => {
          // no need this
          // this.orders = data
        })
      },
      deep: true
    }
  },
  methods: {
    showHideDetails (id) {
      console.log(id)
      for (var prop in this.showDetails) {
        if (parseInt(prop) !== parseInt(id)) {
          this.showDetails[prop] = false
        }
      }
      this.showDetails[id] = !this.showDetails[id]
    },
    async searchOrders () {
      // this.orders = this.getOrders()
      this.getOrders()
    },
    async getOrders () {
      this.ordersLoading = true

      const { sortBy, descending, page, rowsPerPage } = this.pagination

      const response = await OrderService.fetchOrderTWCdetailsLimit(page, rowsPerPage, this.search, this.enabledStatuses, this.enabledInstallorDelivery)
      let items = response.data.orders
      if (this.pagination.sortBy) {
        items = items.sort((a, b) => {
          const sortA = a[sortBy]
          const sortB = b[sortBy]

          if (descending) {
            if (sortA < sortB) return 1
            if (sortA > sortB) return -1
            return 0
          } else {
            if (sortA < sortB) return -1
            if (sortA > sortB) return 1
            return 0
          }
        })
      }

      const totalResponse = await OrderService.countOrderTWCdetails(page, rowsPerPage, this.search, this.enabledStatuses, this.enabledInstallorDelivery)
      this.totalOrders = totalResponse.data.count

      if (this.totalOrders === 0) {
        this.loadingText = 'No orders found.'
      }

      this.ordersLoading = false
      var tempArray = []
      var newItems = []
      var count = 1
      for (var prop in items) {
        const item = items[prop]
        if (!tempArray.includes(item.orderID.orderCode)) {
          item.id = count++
          newItems.push(item)
        }
        tempArray.push(item.orderID.orderCode)
      }
      this.orders2 = items
      this.orders = newItems
      return items
    },
    selectOrder (orderID) {
      this.selectedOrder = this.orders.find(function (order) {
        let _orderId = order.orderID._id
        if (_orderId === orderID) {
          return order
        }
      })
      if (this.selectedOrder.orderID.customerID.address) {
        this.selectedCustomerAddress = this.selectedOrder.orderID.customerID.address.address + ', ' + this.selectedOrder.orderID.customerID.address.city + ', ' + this.selectedOrder.orderID.customerID.address.state + ', ' + this.selectedOrder.orderID.customerID.address.postcode
      }
      this.customerDialog = true
    },
    getProducts (orderCode) {
      var imgs = ''
      for (var index in this.orders2) {
        let item = this.orders2[index]
        // console.log(item.type)
        if (item.orderID.orderCode === orderCode) {
          // console.log(item.type)
          imgs = imgs + this.productAssets[item.type]
        }
      }
      return imgs
    },
    getSubProductsHtml (orderCode) {
      return '<h2>Pratik Testing: ' + orderCode + '</h2>'
    },
    getOrdersByOrderCode (orderCode) {
      var newItems = []
      for (var index in this.orders2) {
        let item = this.orders2[index]
        if (item.orderID.orderCode === orderCode) {
          newItems.push(item)
        }
      }
      return newItems
    },
    deliveryOrInstall (order) {
      if (order.install > 0) {
        return '<img class="delivery-install2" src="/static/productAssets/Install.png">'
      } else {
        return '<img class="delivery-install2" src="/static/productAssets/Delivery.png">'
      }
    },
    getStatusHtml (status) {
      if (status === 'Completed') {
        return '<div class="twc-status status-green">' + status + '</div>'
      } else {
        return '<div class="twc-status status-blue">' + status + '</div>'
      }
    }
  }
}
</script>
<style>
.productImage {
  width: 20px; display: inline-block; margin-right: 7px;
}
.delivery-install2 {
  width: 50px; display: inline-block;
}
.twc-status {
  width: 90%; margin: 0 auto; color: #ffffff; padding: 10px; text-align: center;
}
.status-green {
  background: #61d836;
}
.status-blue {
  background: #56c1ff;
}
th.column.sortable {
  text-align: center !important;
}

</style>



// WEBPACK FOOTER //
// src/components/senttotwc/SentToTWC.vue